import { Card, CardContent } from "../../components/ui/card";
import { Users, FileText, TrendingUp, Euro } from 'lucide-react';

/**
 * 4-card grid summarizing key admin metrics.
 * Returns null when `dashboard` data isn't loaded yet.
 */
export default function AdminStatsCards({ dashboard }) {
  if (!dashboard) return null;
  return (
    <div className="grid md:grid-cols-4 gap-6 mb-8">
      <Card>
        <CardContent className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-slate-500">Utilisateurs</p>
              <p className="text-3xl font-bold text-slate-900">{dashboard.users.total}</p>
              <p className="text-xs text-green-600">+{dashboard.users.recent_7d} cette semaine</p>
            </div>
            <div className="w-12 h-12 bg-violet-100 rounded-xl flex items-center justify-center">
              <Users className="w-6 h-6 text-violet-600" />
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-slate-500">Commandes DCE</p>
              <p className="text-3xl font-bold text-slate-900">{dashboard.dce_orders.total}</p>
              <p className="text-xs text-amber-600">{dashboard.dce_orders.pending_delivery} à livrer</p>
            </div>
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center">
              <FileText className="w-6 h-6 text-blue-600" />
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-slate-500">Abonnements</p>
              <p className="text-3xl font-bold text-slate-900">{dashboard.subscriptions.total}</p>
              <p className="text-xs text-slate-500">{dashboard.users.paid} actifs</p>
            </div>
            <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center">
              <TrendingUp className="w-6 h-6 text-green-600" />
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-slate-500">Revenus Total</p>
              <p className="text-3xl font-bold text-green-600">{dashboard.total_revenue.toFixed(2)} €</p>
              <p className="text-xs text-slate-500">DCE + Abonnements</p>
            </div>
            <div className="w-12 h-12 bg-emerald-100 rounded-xl flex items-center justify-center">
              <Euro className="w-6 h-6 text-emerald-600" />
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
